import React from "react";

import { Text, TextDate } from "@performyard/py-components";

import { useReviewCycleBuilderPageContext } from "../../hooks/ReviewCycleBuilderPageContext";

import BaseReviewCycleDetailsCard from "../BaseReviewCycleDetailsCard";

type ReviewCycleInformationCardProps = {
	width: Parameters<typeof BaseReviewCycleDetailsCard>[0]["width"];
};

const ReviewCycleInformationCard = ({ width }: ReviewCycleInformationCardProps) => {
	const { reviewCycleDetails } = useReviewCycleBuilderPageContext();

	const startDate = reviewCycleDetails?.startDate;
	const dueDate = reviewCycleDetails?.dueDate;
	const group = reviewCycleDetails?.groupName;

	const lookupWorkflow = reviewCycleDetails?.lookupWorkflow;
	const workflowName = lookupWorkflow?.name;
	const isWorkflowDeleted = !lookupWorkflow || !!lookupWorkflow.deletedAt;

	return (
		<BaseReviewCycleDetailsCard width={width}>
			<div className="flex flex-col gap-4">
				<Text size="paragraph-3" weight="semi-bold" color="neutral-9">
					Review Cycle Information
				</Text>
				<div className="flex flex-col gap-2">
					<div className="flex gap-1">
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9" overrideElement="span">
							Start Date:
						</Text>{" "}
						{startDate && (
							<TextDate
								size="paragraph-3"
								dateSize="medium"
								date={startDate}
								overrideElement="span"
								hasTime={false}
							></TextDate>
						)}
					</div>
					<div className="flex gap-1">
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9" overrideElement="span">
							Due Date:
						</Text>{" "}
						{dueDate && (
							<TextDate
								size="paragraph-3"
								dateSize="medium"
								date={dueDate}
								overrideElement="span"
								hasTime={false}
							></TextDate>
						)}
					</div>
					<div className="flex gap-1">
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9" overrideElement="span">
							Group:
						</Text>{" "}
						<Text size="paragraph-3" weight="regular" color="neutral-9" overrideElement="span">
							{group || "None"}
						</Text>
					</div>
					<div className="flex gap-1">
						<Text size="paragraph-3" weight="semi-bold" color="neutral-9" overrideElement="span">
							Template:
						</Text>{" "}
						<div className="py-line-clamp-1 min-w-0 flex-1">
							{isWorkflowDeleted && (
								<Text size="paragraph-3" weight="regular" color="neutral-9" overrideElement="span">
									(deleted){" "}
								</Text>
							)}
							<Text size="paragraph-3" weight="regular" color="neutral-9" overrideElement="span">
								{workflowName || "None"}
							</Text>
						</div>
					</div>
				</div>
			</div>
		</BaseReviewCycleDetailsCard>
	);
};

export default ReviewCycleInformationCard;
